import { useQuery } from '@apollo/client';
import { useEntity } from '@avangard/utils/entity';

import { ChatEntityList } from '@modules/chat/entities';
import { GetStudentsChatsQuery } from '@modules/chat/graphql';

import type { QueryHookOptions } from '@apollo/client';
import type {
    GetStudentsChatsQueryType,
    GetStudentsChatsQueryVariables,
} from '@modules/types/graphql';

const useStudentsChats = (
    options: QueryHookOptions<GetStudentsChatsQueryType, GetStudentsChatsQueryVariables> = {},
) => {
    const queryResult = useQuery<GetStudentsChatsQueryType, GetStudentsChatsQueryVariables>(
        GetStudentsChatsQuery,
        options,
    );

    const { entities: chats, count } = useEntity(
        () => new ChatEntityList(queryResult.data?.getChats ?? null),
        [queryResult.data],
    );

    return {
        chats,
        count,
        ...queryResult,
    };
};

export { useStudentsChats };
